import React from 'react'
import AppNavbar from '../../../components/Navbar'
import { Form, Button, Container, Card, Row, Col, Spinner } from 'react-bootstrap'
import './login.css'
import { Link } from 'react-router-dom'
import google from '../../../images/google.svg'
import eye from '../../../images/eye.svg'
import firebase from 'firebase/compat/app'
import 'firebase/compat/auth';
import Profile from '../../profile/profile'
import { useState } from 'react'
import { useEffect } from 'react'
import {FaEye, FaEyeSlash} from 'react-icons/fa'

import { useNavigate } from 'react-router-dom';




const firebaseConfig = {
    apiKey: "AIzaSyBKWdYhj6i6NcBAiXmhAktyI_bAMwAJuOo",
    authDomain: "tripz-travel-bot.firebaseapp.com",
    projectId: "tripz-travel-bot",
    storageBucket: "tripz-travel-bot.appspot.com",
    messagingSenderId: "720844828187",
    appId: "1:720844828187:web:00adcaa6e56ca989d0d2be",
    measurementId: "G-5BCYRZXXNW"
  };
  
  
  firebase.initializeApp(firebaseConfig)



const Signup = ({setUserData}) => {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [agreeChecked, setAgreeChecked] = useState(false);
  const [nameError, setNameError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [showVerificationCard, setShowVerificationCard] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  
  const [verificationError, setVerificationError] = useState(false);
  const navigate = useNavigate();

    useEffect(() => {
        firebase.auth().onAuthStateChanged((user) => {
          if (user) {
            setUser(user);
          } else {
            setUser(null);
          }
        });
      }, []);

      const handleEmailSignUp = (e) => {
        e.preventDefault();
        
       let isValid = true;

        // Validate name
        if (name.trim() === '') {
          setNameError('Please fill in your name');
          isValid = false;
        } else {
          setNameError('');
        }
    
        // Validate email
        if (email.trim() === '') {
          setEmailError('Please fill in your email');
          isValid = false;
        } else {
          setEmailError('');
        }

        // Validate password
    if (password.length < 8) {
      setPasswordError('Password must be at least 8 characters long');
      isValid = false;
    } else {
      setPasswordError('');
    }
    
        // Validate checkbox
        if (!agreeChecked) {
          alert('Please agree to the terms before signing up.');
          isValid = false;
        }
        if (isValid) {
          
          firebase
  .auth()
  .createUserWithEmailAndPassword(email, password)
  .then((result) => {
    result.user
      .updateProfile({
        displayName: name,
      })
      .then(() => {
        const retrievedUserData = {
          name: result.user.displayName,
          email: result.user.email,
         
        };
        setUserData(retrievedUserData);
        setUser(result.user);

        result.user
          .sendEmailVerification()
          .then(() => {
            // Verification email sent successfully
            setShowVerificationCard(true);
          })
          .catch((error) => {
            // Error sending verification email
            console.error('Email verification error:', error);
            setVerificationError(true);
          });
      })
      .catch((error) => {
        // Error updating user profile
        console.error('Update profile error:', error);
      });
  })
  .catch((error) => {
    // Handle sign-up errors
    console.error('Email sign-up error:', error);
    const errorCode = error.code;
    let errorMessage = '';

    switch (errorCode) {
      case 'auth/invalid-email':
        errorMessage = 'Invalid email format.';
        break;
     
      default:
        errorMessage = 'An error occurred. Please try again later.';
    }

    setErrorMessage(errorMessage);
  });

         }
       };
     
   
     const handleVerifyEmail = () => {
        const user = firebase.auth().currentUser;
    
        if (user) {
          user
          .reload()
          .then(() => {
            if (user.emailVerified) {
              // Email is verified, navigate to profile
              navigate('/verify-email');
            } else {
              // Email is not verified
              setVerificationError(true);
              navigate('/unverified');
            }
          })
          .catch((error) => {
            console.error('Email verification error:', error);
            setVerificationError(true);
          });
      }
    };

    const provider = new firebase.auth.GoogleAuthProvider();
    
    const handleSignUp = () => {
      if (!agreeChecked) {
        alert('Please agree to the terms before signing up.');
        return;
      }
    
      // setLoading(true); // Set loading state to true before initiating signup
    
     
      firebase
        .auth()
        .signInWithRedirect(provider)
        .catch((error) => {
          setLoading(false); // Set loading state to false in case of error
          // Handle sign-up errors
          console.error('Google sign-up error:', error);
        });
    };
    
    
    useEffect(() => {
      firebase
        .auth()
        .getRedirectResult()
        .then((result) => {
          if (result.user) {
            // Successful sign-up with Google
            const { displayName, email } = result.user;
            const retrievedUserData = {
              name: displayName,
              email: email,
            };
            setUserData(retrievedUserData);
            setUser(result.user);
            navigate('/profile');
          } else {
            setLoading(false); // If no user, set loading to false to render the signup component
          }
        })
        .catch((error) => {
          // Handle sign-up errors
          console.error('Google sign-up error:', error);
          setLoading(false);  
          // Set the error message in the state
        });
    }, []);
    
    //   const handleSignUp = () => {
       
    //     if (!agreeChecked) {
    //       alert('Please agree to the terms before signing up.');
    //       return;
    //     }
       
    //     const provider = new firebase.auth.GoogleAuthProvider();
    //     firebase
    //       .auth()
    //       .signInWithPopup(provider)
    //       .then((result) => {
    //         // Successful sign-up with Google
    //         const user = result.user;
    // const name = user.displayName;
    // const email = user.email;
    

    // // Set user data and navigate to profile
    // setUserData({
    //   name,
    //   email,
    
    // });
    // setUser(user);
    // navigate('/profile');
    //       })
    //       .catch((error) => {
    //         // Handle sign-up errors
    //         console.error('Google sign-up error:', error);
    //       });
        
    //   };
      
      const togglePasswordVisibility = (e) => {
        e.preventDefault()
        setShowPassword(!showPassword);
      };
  return (
    <div>
     <AppNavbar/>
     <div>
     {loading ? (  <div>
     
     <div className='justify-content-center align-items-center text-center my-5 py-5'>
     <Spinner animation="border" role="status">
           <span className="visually-hidden">Loading...</span>
         </Spinner>
         </div>
       
      </div>):(
         <Container fluid style={{background:'#F9F9F9'}} className='justify-content-center align-items-center text-align-center p-3 p-md-5'>
         {!showVerificationCard ? (
          <div>
            <Card style={{background:'#fff', maxWidth:'45rem'}} className='p-3 p-md-5 m-auto my-4 border-0 '>
                <h3 className='text-center welcome'>Welcome to Tripz!</h3>
                <Form className='p-2 p-md-5 py-3 '>
                <Form.Group className="mb-3" controlId="formBasicName">
            <Form.Label className='login-form-label'>Full Name</Form.Label>
            <Form.Control type="text" placeholder="Enter full name " value={name} onChange={(event) => setName(event.target.value)}
              isInvalid={nameError !== ''}className='py-2' />
              <Form.Control.Feedback type="invalid">
              {nameError}
            </Form.Control.Feedback>
            
          </Form.Group>
                <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label className='login-form-label'>Email address</Form.Label>
            <Form.Control type="email" placeholder="Enter email address" className='py-2' value={email} onChange={(event) => setEmail(event.target.value)}
              isInvalid={emailError !== ''} />
             <Form.Control.Feedback type="invalid">
              {emailError}
            </Form.Control.Feedback>
            <Form.Text className="text-danger my-2">{errorMessage}</Form.Text>
          </Form.Group>
    
          <Form.Group className="mb-3" controlId="formBasicPassword">
            <Form.Label className='login-form-label'>Password</Form.Label>
            <div className='input-box '>
            <button onClick={togglePasswordVisibility} className='eye border-0' style={{background:"#fff"}}>
        {showPassword ? <FaEyeSlash /> : <FaEye />}
      </button>
            
            <Form.Control   type={showPassword ? 'text' : 'password'} placeholder="Password" className='py-2' value={password} onChange={(event) => setPassword(event.target.value)}
              isInvalid={passwordError !== ''}/>
              <Form.Control.Feedback type="invalid">
              {passwordError}
            </Form.Control.Feedback>
            </div>
            
          </Form.Group>
          <Form.Group className="mb-3 align-items-center d-flex gap-2" controlId="formBasicCheckbox">
            
            <Form.Check type="checkbox" checked={agreeChecked}
              onChange={(event) => setAgreeChecked(event.target.checked)}/>
          <Form.Label className='mt-1'>I agree to the <span><a className='forgot-password'>terms of service</a></span> and <span><a className='forgot-password'>privacy policies</a></span> </Form.Label>
          </Form.Group>
          <div className=' text-center mt-5'>
          <Button type="submit" className='border-0 login-btn' onClick={handleEmailSignUp} >
           Create an Account
          </Button>
          
          </div>
            </Form>
            <div className='text-center mt-3'>
            <h5 className='account'>Already have an account?  <span><Link to='/login' className='forgot-password'>Log in</Link></span></h5>
           
            </div>
            </Card>
            <div className=' justify-content-center align-items-center mt-5'>
                <div className='d-flex flex-row justify-content-center gap-3 align-items-center'>
                    <div className='line'></div>
                    <p className='line-p'>or</p>
                    <div className='line'></div>
                </div>
                <div className='align-items-center justify-content-center text-center mt-4'>
                    <Button onClick={handleSignUp}className='google-login border-0 '> <img src= {google} alt='google'/> &nbsp; &nbsp;Sign up with Google</Button>
                </div>
            </div>
            </div>
            ) : ( <Card style={{background:'#fff', maxWidth:'42rem'}} className='p-3 p-md-5 m-auto my-4 border-0 '>
            <h3 className='text-center welcome'>Verification</h3>
           <p className='account mt-4' style={{fontWeight:'16px'}}>Congratulations! Your account has been created successfully. Kindly verify your email address by clicking on the verification link sent to your email address. Click to check if verication is successful</p>
           <div className='justify-content-center align-items-center text-center mt-4'>
           <Button onClick={handleVerifyEmail}className='' style={{height: '48px',
    width: '241px',
    
    borderRadius: '8px',
    
    backgroundColor: '#008080'}}>Verify Email</Button>
    </div>
       
        
          </Card>)}
    
         </Container>
         
      )}
     </div>
    
   
    </div>
  )
}

export default Signup
